/**
 * bz-gaba-precursor-guide.js
 * GABA Precursor Guide — Page JavaScript
 * Inherits all logic from adhd-supplements-guide.js pattern.
 * Lane-specific config: ELITE recommended, WELCOME10 discount, GABA symptom messages.
 * Created: 2026-04-26 — Session (GABA+Dopamine Shopify port)
 */

/* ─────────────────────────────────────────────────────────────────────
   1. SHARED CONFIG  (inline — mirrors adhd-supplements-guide.js structure)
   ───────────────────────────────────────────────────────────────────── */

window.BZ = window.BZ || {};

BZ.PRODUCTS = {
  uk: {
    elite:    { name: 'FOCUS ELITE™',    shortName: 'ELITE',    price: '£47', priceSub: '£39.48/mo', url: 'https://www.brainzyme.com/products/brainzyme-elite', cart: 'https://www.brainzyme.com/cart/31430974963790:1', purpose: 'Stress-free focus, mood & brain health' },
    pro:      { name: 'FOCUS PRO™',      shortName: 'PRO',      price: '£29', priceSub: '£24.36/mo', url: 'https://www.brainzyme.com/products/brainzyme-professional-stronger-formula', cart: 'https://www.brainzyme.com/cart/31430904086606:1', purpose: 'Strong focus, motivation & memory' },
    original: { name: 'FOCUS ORIGINAL™', shortName: 'ORIGINAL', price: '£18', priceSub: '£15.12/mo', url: 'https://www.brainzyme.com/products/brainzyme-original-milder-formula', cart: 'https://www.brainzyme.com/cart/31430979387470:1', purpose: 'Mild everyday focus & calm mood' }
  }
};

BZ.MARKETS = {
  uk: {
    lang: 'en',
    proofStrip: [
      '<strong>2,000+</strong> medical professionals trust Brainzyme®',
      '<strong>365-day</strong> money-back guarantee',
      '<strong>GMP & HACCP</strong> certified, made in Scotland'
    ],
    reviewStats: { rating: '4.74', count: '6,020+', source: 'verified reviews' }
  }
};

/* ─────────────────────────────────────────────────────────────────────
   2. LP_CONFIG — GABA lane
   ───────────────────────────────────────────────────────────────────── */

var LP_CONFIG = {
  product: 'elite',
  market: 'uk',
  discountCode: 'WELCOME10',
  recommendedSku: 'elite'
};

/* ─────────────────────────────────────────────────────────────────────
   4. PLAN YOUR PATH — GABA lane (Tab 2 = lifestyle, Tab 3 = formula quiz)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  document.addEventListener('DOMContentLoaded', function () {

    /* Tab switching */
    var tabs = document.querySelectorAll('.planpath-tab');
    var panels = document.querySelectorAll('.planpath-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.remove('active'); });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var target = tab.getAttribute('data-tab');
        var panel = document.querySelector('.planpath-panel[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });

    /* Formula quiz — GABA lane (stepper) */
    var market = 'uk';
    var p = BZ.PRODUCTS[market];
    var QUIZ_RESULTS = {
      original: { name: p.original.name, blurb: 'Mild everyday support — L-Theanine + essential nutrients for steady, calm focus.', url: p.original.cart },
      pro:      { name: p.pro.name,      blurb: 'Strong dopamine-pathway support with tyrosine + B-complex for motivated, clear focus.', url: p.pro.cart },
      elite:    { name: p.elite.name,    blurb: 'The most complete formula — GABA precursors, adaptogens, and 29 ingredients for stress-free focus and positive mood.', url: p.elite.cart }
    };

    var stepper = document.getElementById('ppQuizStepper');
    if (stepper) {
      var track = document.getElementById('ppQuizTrack');
      var currentStep = 0;
      var votes = {};

      function goToSlide(n) {
        currentStep = n;
        track.querySelectorAll('.pp-quiz-slide').forEach(function(s) {
          var step = parseInt(s.getAttribute('data-step'), 10);
          var isTarget = (step === n + 1);
          if (isTarget) s.style.display = '';
          s.classList.toggle('active', isTarget);
        });
        if (n >= 3) showResult();
      }

      function showResult() {
        var score = { original: 0, pro: 0, elite: 0 };
        Object.keys(votes).forEach(function(k) { score[votes[k]]++; });
        var winner = 'elite';
        if (score.pro > score.elite && score.pro >= score.original) winner = 'pro';
        else if (score.original > score.elite && score.original > score.pro) winner = 'original';
        var res = QUIZ_RESULTS[winner];
        document.getElementById('ppQuizName').textContent = res.name;
        document.getElementById('ppQuizBlurb').textContent = res.blurb;
        var cta = document.getElementById('ppQuizCta');
        cta.href = res.url;
        cta.textContent = 'Try it — 365-day returns';
      }

      goToSlide(0);

      var advancing = false;
      stepper.querySelectorAll('input[type="radio"]').forEach(function(radio) {
        radio.addEventListener('change', function() {
          stepper.querySelectorAll('input[name="' + radio.name + '"]').forEach(function(r) {
            r.closest('.pp-quiz-option').classList.toggle('selected', r.checked);
          });
          votes[radio.name] = radio.value;
          var targetSlide = parseInt(radio.closest('.pp-quiz-slide').getAttribute('data-step'), 10);
          if (!advancing) {
            advancing = true;
            setTimeout(function() { advancing = false; goToSlide(targetSlide); }, 280);
          }
        });
      });

      var resetBtn = document.getElementById('ppQuizReset');
      if (resetBtn) {
        resetBtn.addEventListener('click', function() {
          votes = {};
          currentStep = 0;
          stepper.querySelectorAll('input[type="radio"]').forEach(function(r) {
            r.checked = false;
            r.closest('.pp-quiz-option').classList.remove('selected');
          });
          var resultSlide = document.getElementById('ppQuizResult');
          if (resultSlide) resultSlide.style.display = 'none';
          goToSlide(0);
        });
      }
    }
  });
})();

/* ─────────────────────────────────────────────────────────────────────
   5. PAGE INTERACTIONS (accordion, symptom checker, progress bar, sticky CTA, stat counters)
   ───────────────────────────────────────────────────────────────────── */

/* Accordion toggle — shared pattern */
function toggleAccordion(btn) {
  var isOpen = btn.getAttribute('aria-expanded') === 'true';
  var panel = btn.nextElementSibling;
  var chevron = btn.querySelector('.accordion-chevron');
  if (isOpen) {
    btn.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = null;
    panel.classList.remove('open');
    if (chevron) chevron.textContent = '+';
  } else {
    btn.setAttribute('aria-expanded', 'true');
    panel.classList.add('open');
    panel.style.maxHeight = panel.scrollHeight + 'px';
    if (chevron) chevron.textContent = '−';
  }
}

/* Symptom checker — GABA lane messages */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.sign-item.selectable');
    var countEl = document.getElementById('symptomCount');
    var resultEl = document.getElementById('symptomResult');
    var count = 0;

    var MESSAGES = [
      null,
      'One sign &mdash; the lifestyle section on lifestyle factors is a great starting point.',
      'A couple of signs &mdash; nutritional support for your nervous system is worth considering.',
      '[N] signs &mdash; your GABA pathways could benefit from a targeted precursor approach. Read on.',
      '[N] of 6 signs &mdash; a multi-pathway precursor formula like FOCUS ELITE may be a good fit.',
      '[N] of 6 signs &mdash; this strongly suggests your nervous system would benefit from precursor-based support.',
      '[N] of 6 signs &mdash; FOCUS ELITE was designed for exactly this pattern of symptoms.'
    ];

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var checked = item.getAttribute('aria-checked') === 'true';
        if (checked) {
          item.setAttribute('aria-checked', 'false');
          item.classList.remove('selected');
          count--;
        } else {
          item.setAttribute('aria-checked', 'true');
          item.classList.add('selected');
          count++;
        }
        if (countEl) countEl.textContent = count;
        if (resultEl) {
          if (count === 0) {
            resultEl.innerHTML = '';
            resultEl.style.display = 'none';
          } else {
            var msg = MESSAGES[count] || MESSAGES[MESSAGES.length - 1];
            resultEl.innerHTML = msg.replace('[N]', count);
            resultEl.style.display = 'block';
          }
        }
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.click(); }
      });
    });
  });
})();

/* Buyer's guide checklist progress dots */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.guide-checklist li[data-check]');
    var dots = document.querySelectorAll('.check-dot');
    var label = document.getElementById('checkLabel');
    if (!items.length || !dots.length) return;

    var seen = new Set();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var n = entry.target.getAttribute('data-check');
          seen.add(n);
          dots.forEach(function (d) {
            if (seen.has(d.getAttribute('data-check'))) d.classList.add('active');
          });
          if (label) label.textContent = seen.size + '/6 explored';
        }
      });
    }, { threshold: 0.6 });

    items.forEach(function (item) { obs.observe(item); });
  });
})();

/* Animated stat counters */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('[data-target]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target'));
        var isFloat = target % 1 !== 0;
        var suffix = el.innerHTML.replace(/[\d.]/g, '').trim();
        var start = 0;
        var duration = 1200;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var val = isFloat ? (progress * target).toFixed(1) : Math.floor(progress * target);
          el.innerHTML = val + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { obs.observe(el); });
  });
})();

/* Progress bar + sticky CTA — GABA lane */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('progressBar');
    var lbl = document.getElementById('progressLabel');
    var cta = document.getElementById('stickyCta');
    var ctaText = document.getElementById('stickyCtaText');
    var ctaLink = document.getElementById('stickyCtaLink');

    var MESSAGES = [
      { pct: 0.05, text: 'Honest science, no hype', label: 'Learn more', url: '#shelfGrid' },
      { pct: 0.20, text: 'The precursor approach', label: 'See the science', url: '#shelfGrid' },
      { pct: 0.40, text: '365-day money-back guarantee', label: 'Try FOCUS ELITE Risk-Free', url: '#shelfGrid' },
      { pct: 0.60, text: '6,020+ verified reviews', label: 'Try FOCUS ELITE', url: '#shelfGrid' }
    ];

    function onScroll() {
      var scrolled = window.scrollY;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      var pct = total > 0 ? scrolled / total : 0;

      if (bar) bar.style.width = (pct * 100) + '%';
      if (lbl) lbl.textContent = Math.round(pct * 100) + '%';

      if (cta) {
        if (pct > 0.10 && pct < 0.95) {
          cta.classList.add('visible');
        } else {
          cta.classList.remove('visible');
        }
      }

      var active = MESSAGES[0];
      for (var i = 0; i < MESSAGES.length; i++) {
        if (pct >= MESSAGES[i].pct) active = MESSAGES[i];
      }
      if (ctaText) ctaText.textContent = active.text;
      if (ctaLink) {
        ctaLink.textContent = active.label;
        ctaLink.href = active.url;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();
